// 支付相关接口
export default {
  ORDER_TRANSACTIONS_CLOSE: '/api/v3/order/transactions/close',                              // 关闭订单(学生端)

  ORDER_TRANSACTIONS_CREATE: '/api/v3/order/transactions/create',                              // 创建订单(学生端)

  ORDER_TRANSACTIONS_INFO: '/api/v3/order/transactions/info',                              // 订单详情(学生端)

  ORDER_TRANSACTIONS_INFO_TASKRELATION: '/api/v3/order/transactions/info/taskRelation',                              // 缴费任务查看订单详情(学生端)

  ORDER_ORDER_COUPON_VISIBLELIST: '/api/v3/order/coupon/visibleList',                              // 获取用户的优惠券列表(学生端)

  // ORDER_ORDER_COUPON_OPTIMAL: '/api/v3/order/coupon/optimal',                              // 获取最优优惠券(学生端)

  ORDER_ORDER_COUPON_OPTIMAL: '/api/v3/order/transactions/coupon/optimal',                              // 获取最优优惠券(学生端)

  ORDER_ORDER_AMOUNT_CALCULATE: '/api/v3/order/transactions/amount/calculate',                              // 计算订单金额(学生端)

  ORDER_ORDER_TRANSATIONS_SWITCH: '/api/v3/order/transactions/switch',                              // 获取支付方式(学生端)

  ORDER_TRANSACTIONS_TASKRELATION_PAY: '/api/v3/order/transactions/pay',                              // 订单支付(学生端)

  COMMON_QRCODE_PRODUCE: '/api/v3/common/qrcode/produce',                              // 二维码生成

  ORDER_COUPON_CODE_EXCHANGE: '/api/v3/order/coupon/code/exchange',                              // 兑换优惠码(学生端)

  ORDER_TRANSACTIONS_TASKRELATION_REFUND: '/api/v3/order/transactions/refund',                              // 订单退款(学生端)

  ORDER_TRANSACTIONS_TASKRELATION_REFUND_INFO: '/api/v3/order/transactions/refund/info',                             // 订单退款信息(学生端)

  ORDER_TRANSACTIONS_TASKRELATION_REFUND_VALID: '/api/v3/order/transactions/refund/valid',                             // 检查是否能退款

  ORDER_TRANSACTIONS_TASKRELATION_USERORDER_LIST: '/api/v3/order/transactions/userOrder/list',                           // 用户的订单中心(学生端)

  ORDER_TRANSACTIONS_FEE_INFO: '/api/v3/order/fee/feeTaskRelation/info',                            // 获取缴费任务的费用信息

  ORDER_TRANSACTIONS_FEE_STATUS: '/api/v3/order/transactions/status',                            // 查询订单状态(学生端)

  ORDER_TRANSACTIONS_FEEDBACK: '/api/v3/order/transactions/feedback'                            // 无法支付反馈

}



// WEBPACK FOOTER //
// ./src/assets/api/constant/paymentV3.js